import React, { useState } from "react";

import { Layout } from "antd";

import "./index.css";

const { Sider, Content } = Layout;

export default function NavLayout({ NavList, MyContent }) {
  const [collapsed, setCollapsed] = useState(false);
  const bol =
    window.location.pathname.indexOf("/user/workbench/") &&
    window.location.pathname.indexOf("/mymymanager/service") &&
    window.location.pathname.indexOf("/mymymanager/workbench");
  // console.log(bol);
  function onCollapse(curr) {
    setCollapsed(curr);
  }

  return (
    <Layout className="navlayout">
      {bol === -1 && (
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
          <NavList />
        </Sider>
      )}
      <Content>
        <MyContent />
      </Content>
    </Layout>
  );
}
